<template>
  <div class="EmpleadosListado">
    <md-table v-model="filtro_publicaciones" md-card md-fixed-header>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Publicaciones registradas</h1>
        </div>
        <md-field md-clearable class="md-toolbar-section-end">
          <md-input placeholder="Buscar publicación..." v-model="buscar" />
        </md-field>
      </md-table-toolbar>
      <md-table-empty-state :md-label="mensaje_tabla" />
      <md-table-row slot="md-table-row" slot-scope="{ item }" class="md-accent" md-selectable="single">
        <md-table-cell md-label="Titulo" md-sort-by="titulo_pub">{{ item.titulo_pub.substr(0,30).toUpperCase() }}{{ item.titulo_pub.length > 30 ?'...': '' }} </md-table-cell>
        <md-table-cell md-label="Fecha" md-sort-by="fecha_pub">{{ item.fecha_pub }}</md-table-cell>
        <md-table-cell md-label="Categoría" md-sort-by="desc_cat"> {{ item.desc_cat.toUpperCase() }} </md-table-cell>
        <md-table-cell md-label="Tipo" md-sort-by="tipo_pub"> {{ item.tipo_pub.toUpperCase() }} </md-table-cell>
        <md-table-cell md-label="Ref." md-sort-by="referencias">{{item.referencias}}</md-table-cell>
        <md-table-cell md-label="Arc." md-sort-by="archivos">{{item.archivos}}</md-table-cell>
        <md-table-cell md-label="Acciones">
          <md-button class="md-icon-button md-dense" @click="editarPublicacion(item.id_pub)">
            <md-icon>edit</md-icon>
            <md-tooltip md-direction="left">Editar</md-tooltip>
          </md-button>
          <md-button class="md-icon-button md-dense" @click="eliminar(item)">
            <md-icon>delete</md-icon>
            <md-tooltip md-direction="left">Eliminar</md-tooltip>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-progress-bar md-mode="indeterminate" v-if="cargando_tabla" />
    <md-card-actions v-if="!cargando_tabla">
      {{filtro_publicaciones.length}} publicaciones, {{arc}} archivos, {{ref}} referencias
    </md-card-actions>
    <md-dialog-confirm :md-active.sync="dialog_eliminar" md-title="Eliminar publicación" :md-content="'¿Esta seguro desea eliminar la publicación con título '+titulo+'?'" md-confirm-text="Si, deseo eliminarla" md-cancel-text="Cancelar" @md-cancel="dialog_eliminar = false" @md-confirm="eliminarPublicacion" />
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";

const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarNombre = (items, term) => {
  if (term) {
    return items.filter(item =>
      toLower(
        item.titulo_pub +
          " " +
          item.fecha_pub +
          " " +
          item.desc_cat +
          " " +
          item.tipo_pub +
          " "
      ).includes(toLower(term))
    );
  }
  return items;
};

export default {
  name: "EmpleadosListado",
  props: ["sb"],
  methods: {
    buscarEnLaTabla() {
      this.filtro_publicaciones = buscarNombre(this.publicaciones, this.buscar);
    },
    obtenerPublicaciones() {
      this.mensaje_tabla = "Cargando publicaciones...";
      this.cargando_tabla = true;
      this.$http
        .post("publicaciones", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            this.mensaje_tabla = "No se encontraron publicaciones";
            this.cargando_tabla = false;
            if (response.status === 200 && "publicaciones" in response.body) {
              this.publicaciones = response.body.publicaciones;
              this.filtro_publicaciones = response.body.publicaciones;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.mensaje_tabla = "No se encontraron publicaciones";
            this.cargando_tabla = false;
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para obtener las publicaciones";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    editarPublicacion(i) {
      this.$router.push({
        name: "PublicacionesEditar",
        params: {
          publicacion: sha1(md5(i))
        }
      });
    },
    eliminar(p) {
      this.titulo = p.titulo_pub;
      this.publicacion = p.id_pub;
      this.dialog_eliminar = true;
    },
    eliminarPublicacion() {
      this.dialog_eliminar = false;
      this.$http
        .post("publicaciones/eliminar", {
          token: this.$session.get("token"),
          publicacion: this.publicacion
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.obtenerPublicaciones();
              this.$parent.sb.texto = response.body.msg;
            } else {
              this.$parent.sb.texto = response.body.error;
            }
            this.$parent.sb.mostrar = true;
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para eliminar la publicación";
            this.$parent.sb.mostrar = true;
          }
        );
    }
  },
  data() {
    return {
      buscar: null,
      publicaciones: [],
      filtro_publicaciones: [],
      dialog_eliminar: false,
      publicacion: null,
      titulo: null,
      arc: 0,
      ref: 0,
      mensaje_tabla: "No se encontraron publicaciones",
      cargando_tabla: false
    };
  },
  watch: {
    buscar(a) {
      this.buscarEnLaTabla();
    },
    filtro_publicaciones(a) {
      var a = 0;
      var b = 0;
      this.filtro_publicaciones.forEach(e => {
        a += parseInt(e.archivos);
        b += parseInt(e.referencias);
      });
      this.arc = a;
      this.ref = b;
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerPublicaciones();
  }
};
</script>